module.exports = __webpack_public_path__ + "static/media/msc2020_work.7dcc0380.png";